import type { ReactElement } from 'react';

const SKELETON_ROW_COUNT = 5;

export function SearchSkeleton(): ReactElement {
  return (
    <div role="status" aria-busy="true" aria-label="Searching the library" className="flex flex-col gap-3 px-6 pt-2">
      <div className="placeholder-stripe h-3 w-24 rounded-full" aria-hidden="true" />
      <ul className="flex flex-col gap-3" aria-hidden="false">
        {Array.from({ length: SKELETON_ROW_COUNT }).map((_, idx) => (
          <li key={idx} className="flex flex-col gap-2 border-b border-[var(--rule)] pb-3 last:border-b-0">
            <div className="placeholder-stripe h-4 w-3/5 rounded" aria-hidden="true" />
            <div className="placeholder-stripe h-3 w-2/5 rounded" aria-hidden="true" />
            <div className="placeholder-stripe h-2.5 w-1/4 rounded" aria-hidden="true" />
          </li>
        ))}
      </ul>
    </div>
  );
}
